import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { EnrollManagerService } from './enroll-manager.service';
import { EnrollPresenterService } from './enroll-presenter.service';

@Injectable({
  providedIn: 'root'
})
export class PayByPhoneService {

  constructor(
    private httpClient: HTTPWrapperContext,
    private enrollPresenterService: EnrollPresenterService,
    private enrollManagerService: EnrollManagerService
  ) { }

  async payByPhone(): Promise<string | HttpErrorResponse> {
    const payload = {
      // leadId: cookie('LEAD'),
      paymentAmount: this.enrollPresenterService.productMonthlyPremium().substring(1),
      productCode: this.enrollManagerService.getProduct().planId,
      prospectId: this.enrollManagerService.getProspectId(),
      applicationSourceType: 'ONX'
    };

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: '/cmcrst/x-services/enroll/paybyphone',
      headers: new HttpHeaders({
      }),
      POST_OR_PUT_PAYLOAD: JSON.stringify(payload)
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
    return this.httpClient.makeRequest(requestConfig);
  }
}
